import React from "react";
import "antd/dist/antd.css";
import { Button, notification, Form, Row, Col, Input, Spin } from "antd";
import Amplify, { Auth, Storage } from "aws-amplify";
import { Link, withRouter } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import newLogo from "../../Images/newLogo.JPG";
import { withAppContext } from "../../store/contextStore";
import { getUserProfile } from "../../api/userProfile";
import { getDetails, update } from "../../api/Apis";
import { getCustomerOrCarrierDetails } from "../../api/OraganizationApis";
import AppConfigs from "../../Config/AppConfig";
import awsConfigure from "../../Config/AwsConfig";
import OtpInput from "react-otp-input";
import NumberFormat from "react-number-format";
import OtpTimer from "otp-timer";

Amplify.configure(awsConfigure);

class DriverLogin extends React.Component {
  state = {
    errors: "",
    visible: false,
    loading: false,
    otpLoginScreen: false,
    otpLoading: false,
    phoneNumber: "",
    otpValue: "",
    signInConfirmation: {},
    phone: "",
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
    console.log("closed");
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
    console.log("closed");
  };

  handleSubmit = (e) => {
    console.log("check");
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(
      ["username", "password"],
      async (err, values) => {
        console.log("check values", values);
        if (!err) {
          this.doLogin(false);
        }
      }
    );
  };

  handleRequest = async (e) => {
    this.setState({ loading: true });
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(["phone"], async (err, values) => {
      this.setState({ phoneNumber: values.phone });
      if (!err) {
        this.handleOtpRequest(values.phone);
      } else {
        this.setState({
          loading: false,
        });
      }
    });
  };

  handleOtpRequest = async (number) => {
    let phoneNumber = number.replace(/[^+0-9]/g, "");
    try {
      await Auth.signIn(phoneNumber)
        .then((response) => {
          if (response) {
            console.log(response);
            this.setState({
              signInConfirmation: response,
              otpLoginScreen: true,
              loading: false,
            });
          }
        })
        .catch((error) => {
          console.log("eror1", error);
          switch (error.code) {
            case "UserNotFoundException":
              notification["error"]({
                message: "Phone Number not registered",
              });
              break;
            case "NotAuthorizedException":
              notification["error"]({
                message: "Phone Number not registered",
              });
              break;
            case "UserLambdaValidationException":
              notification["error"]({
                message: "Phone Number not registered",
              });
              break;
            default:
              notification["error"]({
                message: "Phone Number not registered",
              });
          }
          this.setState({
            loading: false,
            otpLoginScreen: false,
          });
        });
    } catch (error) {
      console.log("eror", error);
    }
  };

  handleOtpChange = (e) => {
    this.setState({
      otpValue: e,
    });
  };

  handleOnChange = (value) => {
    this.setState({
      phone: value,
    });
  };

  doOTPLogin = async () => {
    const { otpValue, signInConfirmation } = this.state;
    this.setState({
      otpLoading: true,
    });
    try {
      await Auth.sendCustomChallengeAnswer(signInConfirmation, otpValue)
        .then(async (response) => {
          console.log(response);
          this.getUserDetails(true, response);
        })
        .catch((error) => {
          console.log("Error", error);
          notification["error"]({
            message: "Invalid code!",
          });
          this.setState({ otpLoading: false });
        });
    } catch (error) {
      console.log("Error", error);
      this.setState({
        otpLoginScreen: false,
      });
    }
  };

  doLogin = async (needUserStatusUpdate) => {
    console.log("DolOgin");
    try {
      this.setState({
        loading: true,
      });
      const user = await Auth.signIn(
        this.props.form.getFieldValue("username"),
        this.props.form.getFieldValue("password")
      );

      this.getUserDetails(needUserStatusUpdate, user);
      // this.getProfile(userDetails.userid);
      // this.props.history.push('/carrier_app/orders');
    } catch (err) {
      console.log(err);
      if (err.code === "UserNotConfirmedException") {
        var code = prompt("Please enter the code which is sent to your mail");
        if (code !== "") {
          this.confirmUser(this.props.form.getFieldValue("username"), code);
        }
      } else if (err.code === "PasswordResetRequiredException") {
        this.setState({
          loading: false,
          errors: err.message,
        });
      } else if (err.code === "NotAuthorizedException") {
        this.setState({
          loading: false,
          errors: err.message,
        });
      } else if (err.code === "UserNotFoundException") {
        this.setState({
          loading: false,
          errors: err.message,
        });
      } else {
        this.setState({
          loading: false,
          errors: err.message,
        });
      }
    }
  };

  getUserDetails = (needUserStatusUpdate, user) => {
    const userDetails = Object.assign(
      {},
      {
        token: user.signInUserSession.idToken.jwtToken,
        userid: user.attributes.sub,
      }
    );
    if (needUserStatusUpdate) {
      let data = {
        entityData: {
          isActive: true,
        },
      };
      update(AppConfigs["entityNames"]["users"], userDetails.userid, data).then(
        (result) => {
          if (result.success) {
            this.setState({
              otpLoading: false,
            });
            console.log("Success");
          } else {
            console.log(result.errors);
            this.setState({
              otpLoading: false,
            });
          }
        }
      );
    }
    this.setState({
      loading: false,
    });
    console.log(userDetails);
    this.props.context.setUser(userDetails, false);
    this.getProfile(userDetails.userid);
  };

  getProfile = (id) => {
    this.setState({
      loading: true,
    });
    getUserProfile(id).then(async (result) => {
      if (result.success) {
        this.setState({
          loading: false,
        });
        let userData = result.data;
        if (userData["profilePic"]) {
          userData["profilePicPath"] = await Storage.get(
            userData["profilePic"]
          );
        }
        localStorage.setItem("orgId", result.data.orgId);
        localStorage.setItem("userDetails", JSON.stringify(userData));
        this.props.context.setUserDetails(userData);
        if (result.data.userProfile === "S") {
          this.props.history.push("/app/oraganizations");
        } else if (result.data.userProfile === "A") {
          getDetails(
            AppConfigs["entityNames"]["organizations"],
            result.data.orgId
          ).then((result) => {
            if (result.success) {
              localStorage.setItem("orgDetails", JSON.stringify(result.data));
              this.props.history.push("/app/loads");
            } else {
              this.setState({
                loading: false,
                errors: result.errors,
              });
            }
          });
        } else if (result.data.userProfile === "CA") {
          console.log(result.data.orgId);
          getCustomerOrCarrierDetails(result.data.orgId).then((result) => {
            if (result.success) {
              console.log(result.data);
              localStorage.setItem("orgDetails", JSON.stringify(result.data));
              // this.props.context.setOrgDetails(result.data);
              this.props.history.push("/carrier_app/allOrders");
            } else {
              this.setState({
                loading: false,
                errors: result.errors,
              });
            }
          });
        } else if (result.data.userProfile === "CU") {
          console.log(result.data.orgId);
          getCustomerOrCarrierDetails(result.data.orgId).then((result) => {
            if (result.success) {
              console.log(result.data);
              localStorage.setItem("orgDetails", JSON.stringify(result.data));
              // this.props.context.setOrgDetails(result.data);
              this.props.history.push("/app/stones");
            } else {
              this.setState({
                loading: false,
                errors: result.errors,
              });
            }
          });
        } else if (result.data.userProfile === "D") {
          console.log(result.data.orgId);
          getCustomerOrCarrierDetails(result.data.orgId).then((result) => {
            if (result.success) {
              console.log(result.data);
              localStorage.setItem("orgDetails", JSON.stringify(result.data));
              this.props.history.push("/app/driver/todo");
            } else {
              this.setState({
                loading: false,
                errors: result.errors,
              });
            }
          });
        }
      } else {
        console.log(result.errors);
        this.setState({
          loading: false,
          errors: result.errors.toString(),
        });
      }
    });
  };

  confirmUser = async (email, code) => {
    try {
      await Auth.confirmSignUp(email, code).then(async (result) => {
        if (result === "SUCCESS") {
          await this.doLogin(true);
        }
      });
    } catch (error) {
      alert("Invalid code");
      this.setState({
        loading: false,
      });
    }
  };

  // AdminLogin = () => {
  //   const { getFieldDecorator } = this.props.form;
  //   console.log(this.state.loading);
  //   return (
  //     <div style={{ marginTop: "15px" }}>
  //       <Form onSubmit={this.handleSubmit}>
  //         <Form.Item>
  //           {getFieldDecorator("username", {
  //             rules: [
  //               {
  //                 required: true,
  //                 message: "Please input your Email Address!",
  //               },
  //             ],
  //           })(
  //             <Input
  //               prefix={
  //                 <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
  //               }
  //               placeholder="Email Address"
  //               style={{ height: "40px" }}
  //             />
  //           )}
  //         </Form.Item>
  //         <Form.Item>
  //           {getFieldDecorator("password", {
  //             rules: [
  //               { required: true, message: "Please input your Password!" },
  //             ],
  //           })(
  //             <Input.Password
  //               prefix={
  //                 <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
  //               }
  //               placeholder="Password"
  //               style={{ height: "40px" }}
  //             />
  //           )}
  //         </Form.Item>
  //         {
  //           this.state.errors && (
  //             <div style={{ textAlign: "center" }}>
  //               <span style={{ color: "#f5222d" }}>{this.state.errors}</span>
  //             </div>
  //           )
  //           //  <Alert
  //           //    message={ this.state.errors }
  //           //    description='Error Logging in.'
  //           //    type='error'
  //           //    showIcon
  //           //  />
  //         }
  //         <Form.Item className="password-row">
  //           {/* <a className="login-form-forgot" href="">Forgot password?</a> */}
  //           <Link to="/forgotPassword">Forgot password?</Link>
  //           {/* <Button
  //               htmlType='submit'
  //               loading={ this.state.loading }
  //             >
  //               <span className='login-now'>LOGIN NOW</span>
  //             </Button> */}
  //           <Button
  //             type="primary"
  //             htmlType="submit"
  //             loading={this.state.loading}
  //             className="login-form-button"
  //           >
  //             Login
  //           </Button>
  //         </Form.Item>
  //         <Form.Item className="password-row">
  //           <Link
  //             to="app/customersignup"
  //             style={{ float: "left", fontWeight: "bold", fontSize: "16px" }}
  //           >
  //             <span className="login-custom"> Customer Registration</span>
  //           </Link>
  //           <Link
  //             to="carrier_login/Signup"
  //             style={{ float: "right", fontWeight: "bold", fontSize: "16px" }}
  //           >
  //             <span className="login-custom">Carrier Registration</span>
  //           </Link>
  //         </Form.Item>
  //       </Form>
  //     </div>
  //   );
  // };

  // DriverLogin = () => {
  // const { getFieldDecorator } = this.props.form;
  // return (
  //   <div style={{ marginTop: "15px" }}>
  //     <Form onSubmit={this.handleRequest}>
  //       <Form.Item>
  //         {getFieldDecorator("phone", {
  //           rules: [{ required: true, message: "Please input your number!" }],
  //         })(
  //           <ReactTelInput
  //             type="text"
  //             id="phone"
  //             flagsImagePath={flags}
  //             name="phone number"
  //             required
  //             classNames="telephoneInput"
  //             defaultCountry="us"
  //             placeholder="Phone Number"
  //           />
  //         )}
  //       </Form.Item>
  //       <Form.Item>
  //         {/* <Link to="/app/verification"> */}
  //         <Button
  //           htmlType="submit"
  //           className="ant-input"
  //           style={{ background: "#0E4D90", color: "white" }}
  //           loading={this.state.loading}
  //         >
  //           Request Code
  //         </Button>
  //         {/* </Link> */}
  //       </Form.Item>
  //     </Form>
  //   </div>
  // );
  // };

  otpLogin = () => {
    return (
      <div>
        <Row style={{ textAlign: "center" }}>
          <span className="sign-upcode">Enter your 6 digit code</span>
        </Row>

        <OtpInput
          containerStyle="otp-Outline"
          value={this.state.otpValue}
          onChange={this.handleOtpChange}
          numInputs={6}
          isDisabled={false}
          className="input-btn-style"
          inputStyle="input-className"
        />
        <Row style={{ textAlign: "center" }}>
          <Spin spinning={this.state.otpLoading} style={{ marginTop: "6px" }}>
            <Input
              type="button"
              addonAfter={
                <OtpTimer
                  seconds={45}
                  minutes={0}
                  resend={() => this.handleOtpRequest(this.state.phoneNumber)}
                  text=" "
                  background={"#E6EDF4"}
                  buttonColor={"#0E4D90"}
                  textColor={"#0E4D90"}
                />
              }
              value="Submit"
              className="code-sent"
              onClick={this.doOTPLogin}
            />
          </Spin>
        </Row>
        <Row style={{ textAlign: "center", marginTop: "1vw" }}>
          <span className="sign-upcode">{this.state.phoneNumber}</span>
        </Row>
        {/* <Row>
          <Form.Item className="password-row" style={{ textAlign: "center" }}>
            <Link
              to="/driverlogin"
              style={{
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              {/* <Button
                className="ant-input"
                style={{ background: "#0E4D90", color: "white" }}
              > 
              <ArrowLeftOutlined />
              <span> Change number </span>
              </Button>
            </Link>
          </Form.Item>
        </Row> */}
      </div>
    );
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { otpLoginScreen } = this.state;
    return (
      <div
        style={{ background: "#0E4D90 0% 0% no-repeat padding-box" }}
        className="admin-login-form"
      >
        <div className="login-fields">
          <Row>
            <Form onSubmit={this.handleRequest}>
              <Row>
                {/* <h2 className="Login" style={{ textAlign: "center" }}>Login</h2> */}
                <div style={{ textAlign: "center" }}>
                  <img src={newLogo} alt="Logo" style={{ width: "50%" }} />
                </div>
              </Row>

              {otpLoginScreen ? (
                this.otpLogin()
              ) : (
                <Col span={24}>
                  <Form.Item>
                    {getFieldDecorator("phone", {
                      rules: [
                        {
                          required: true,
                          message: "Please input your number!",
                        },
                      ],
                    })(
                      <NumberFormat
                        className="ant-input-number"
                        placeholder="Phone"
                        onChange={this.handleOnChange}
                        format="+91 (###) ###-####"
                        style={{
                          width: "100%",
                          padding: "4px 11px",
                          height: "40px",
                          fontSize: "14px",
                        }}
                        // allowEmptyFormatting
                        // mask="_"
                      />
                    )}
                  </Form.Item>

                  <Form.Item>
                    <Button
                      htmlType="submit"
                      className="ant-input"
                      style={{ background: "#0E4D90", color: "white" }}
                      loading={this.state.loading}
                    >
                      Request Code
                    </Button>
                  </Form.Item>
                  <Form.Item
                    className="password-row"
                    style={{ textAlign: "center" }}
                  >
                    <p
                      style={{
                        float: "right",
                      }}
                    >
                      Already have an Account?
                      <Link
                        to="/"
                        style={{
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {/* <ArrowLeftOutlined /> */}
                        <span> Click Here to Login</span>
                      </Link>
                    </p>
                  </Form.Item>
                </Col>
              )}
              <h5
                style={{ textAlign: "center", color: "gray", marginTop: "1vw" }}
              >
                Version 1.11.25.04
              </h5>
            </Form>
          </Row>
        </div>
      </div>
    );
  }
}
const WrappedNormalDriverLogin = Form.create({ name: "Login" })(
  withAppContext(withRouter(DriverLogin))
);

export default WrappedNormalDriverLogin;
